import {
  Typography,
  CircularProgress,
  Box,
  Paper,
  Button,
  Card,
  CardContent,
  Divider,
  Container,
} from "@mui/material";
import React from "react";
import { useEffect, useState, useCallback } from "react";
import { useUserContext } from "../../../contexts/ProviderProvider";
import useNotification from "../../../hooks/useNotification";
import { getGeneralEQMAssets } from "../../../API/equipmentManager";
import ServerSideTable from "../../common/ServerSideTable.jsx";
import LazyImage from "../../common/LazyImage";

const AssetTable = () => {
  const user = useUserContext();
  const notify = useNotification();
  const [refresh, setRefresh] = useState(false);

  const [generalProductAssets, setGeneralProductAssets] = useState([]);

  const handlePaginationStateUpdate = useCallback(
    (axiosOptions, page, pageSize, search, filter, ordering) => {
      console.log(`axiosOptions`, axiosOptions);
      console.log(`page`, page);
      console.log(`pagesize`, pageSize);
      console.log(`search`, search);
      console.log(`filter`, filter);
      console.log(`ordering`, ordering);

      return getGeneralEQMAssets(
        user,
        axiosOptions,
        page,
        pageSize,
        ordering,
        search,
        filter
      )
        .then((response) => {
          console.log("got data", response.data.obj.data);
          setGeneralProductAssets(response.data.obj.data);
          return response;
        })
        .catch((e) => {
          if (axios.isCancel(e)) {
            // not an error
          } else {
            console.log("from caller error", e);
            notify("Failed to get jobs");
            return e;
          }
        });
    },
    [user]
  );

  let columns = [];

  if (generalProductAssets.length > 0) {
    console.log("assets has length", generalProductAssets);
    const shape = generalProductAssets[0];
    columns = Object.keys(shape).map((s) => ({
      label: capitalize(s),
      name: s,
    }));
  }

  for (let i = 0; i < columns.length; i++) {
    if (generalProductAssets.length === 0) {
      continue;
    }
    if (columns[i].name.toLowerCase().includes("asset_url")) {
      columns[i].options = {
        customBodyRender: (value) => {
          return (
            <div>
              <LazyImage
                src={value}
                thumbnail
                style={{ height: "50px" }}
              ></LazyImage>
            </div>
          );
        },
      };
    }
  }

  console.log("after building columns", columns);

  const options = { filter: false };

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Card elevation={3}>
        <CardContent>
          <Paper sx={{ p: 3 }}>
            <Box
              sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}
            >
              <Typography variant="h6">General Asset Table</Typography>
              <Button
                variant="outlined"
                onClick={() => setRefresh((prev) => !prev)}
              >
                Refresh
              </Button>
            </Box>
            <ServerSideTable
              //title={"General Assets"}
              data={generalProductAssets || []}
              columns={columns}
              tableConfig={options}
              onTableChange={(a, b, c) => {
                console.log("table update", a, b, c);
              }}
              paginatedRequestFunc={handlePaginationStateUpdate}
            />
          </Paper>
        </CardContent>
      </Card>
    </Container>
  );
};

const capitalize = (key) => {
  // Handle specific cases first, such as abbreviations
  const specialCases = {
    ID: "ID",
  };

  // Split camelCase or snake_case into words
  const words = key
    .replace(/([a-z])([A-Z])/g, "$1 $2") // Split camelCase
    .replace(/_/g, " ") // Replace underscores with spaces (if any)
    .split(" "); // Split into an array of words

  // Capitalize the first letter of each word
  const formattedWords = words.map((word) => {
    if (specialCases[word.toUpperCase()]) {
      return specialCases[word.toUpperCase()];
    }
    return word.charAt(0).toUpperCase() + word.slice(1);
  });

  // Join the words back into a single string
  return formattedWords.join(" ");
};
export default React.memo(AssetTable);
